import type {
  ActivityItem,
  Badges,
  FriendRelation,
  FriendsState,
  InviteInfo,
  TournamentDetails,
  TournamentStatus,
  TournamentSummary,
  UserSearchResult,
} from '@tg/shared';
import { api, type RequestOptions } from '@/api/client';

/** REST endpoints of apps/server/src/social (contracts in @tg/shared/social). */
export const socialApi = {
  badges: (o?: RequestOptions) => api.get<Badges>('/api/me/badges', o),
  friends: (o?: RequestOptions) => api.get<FriendsState>('/api/friends', o),
  search: async (q: string, o?: RequestOptions) =>
    (await api.get<{ users: UserSearchResult[] }>(`/api/friends/search?q=${encodeURIComponent(q)}`, o)).users,
  activity: async (o?: RequestOptions) => (await api.get<{ items: ActivityItem[] }>('/api/friends/activity', o)).items,
  invite: (o?: RequestOptions) => api.get<InviteInfo>('/api/friends/invite', o),
  request: (publicId: number) => api.post<{ relation: FriendRelation }>('/api/friends/request', { publicId }),
  accept: (publicId: number) => api.post<{ relation: FriendRelation }>('/api/friends/accept', { publicId }),
  remove: (publicId: number) => api.post<{ relation: FriendRelation }>('/api/friends/remove', { publicId }),
  inviteToGame: (publicId: number) => api.post<{ ok: true }>('/api/friends/invite-to-game', { publicId }),

  tournaments: async (status: TournamentStatus, o?: RequestOptions) =>
    (await api.get<{ tournaments: TournamentSummary[] }>(`/api/tournaments?status=${status}`, o)).tournaments,
  tournament: (id: string, o?: RequestOptions) => api.get<TournamentDetails>(`/api/tournaments/${id}`, o),
  join: (id: string) => api.post<{ joined: true }>(`/api/tournaments/${id}/join`),
};
